import React from "react";
import { FiArrowRight, FiAward, FiBarChart2, FiBookOpen, FiCode, FiGlobe, FiHeart, FiUsers } from "react-icons/fi";
import "./career.css";

const whyCards = [
  { icon: <FiArrowRight />, title: "Purposeful work", copy: "Solve real-world challenges with global impact." },
  { icon: <FiUsers />, title: "Collaborative culture", copy: "Work across disciplines with trusted teams." },
  { icon: <FiBarChart2 />, title: "Growth and learning", copy: "Mentorship, certifications, and continuous development." },
  { icon: <FiGlobe />, title: "Global opportunities", copy: "Work on international projects with diverse teams." },
];

const openRoles = [
  { icon: <FiCode />, title: "Platform Engineer", copy: "Build scalable infrastructure, cloud-native platforms, and modern enterprise systems." },
  { icon: <FiBarChart2 />, title: "Data Analyst", copy: "Work with analytics and AI teams to transform data into insights that guide business decisions." },
  { icon: <FiUsers />, title: "Delivery Lead", copy: "Coordinate cross-functional teams and manage complex technology programs from planning to execution." },
  { icon: <FiBookOpen />, title: "UX Designer", copy: "Design intuitive digital experiences that simplify complex platforms and improve usability." },
];

const Career: React.FC = () => {
  return (
    <div className="career-page">
      <section className="theme-hero career-hero">
        <div className="theme-hero-copy">
          <p className="theme-kicker">Careers at Stellar</p>
          <h1>Build your career with purpose</h1>
          <p>
            Join a team that ships modern platforms, thoughtful product experiences, and systems
            that help organizations move faster and achieve more.
          </p>
          <div className="theme-actions">
            <a href="#open-roles" className="theme-primary">
              Explore roles <FiArrowRight />
            </a>
            <a href="#culture" className="theme-secondary">
              See our culture <FiArrowRight />
            </a>
          </div>
        </div>

        <div className="theme-hero-art theme-phone-scene" aria-hidden="true">
          <div className="home-visual-dots" />
          <div className="phone-frame phone-frame-back phone-back-left">
            <img src="/assets/hero/business-growth.png" alt="" style={{ objectPosition: "57% top" }} />
          </div>
          <div className="phone-frame phone-frame-back phone-back-right">
            <img src="/assets/hero/services.png" alt="" style={{ objectPosition: "67% top" }} />
          </div>
          <div className="phone-frame phone-frame-main">
            <img src="/assets/hero/incorporation-progress.png" alt="" style={{ objectPosition: "66% top" }} />
          </div>
        </div>
      </section>

      <section className="career-ribbon">
        <div className="ribbon-item"><FiBookOpen /><div><strong>Learn</strong><span>Sharpen skills with continuous learning</span></div></div>
        <div className="ribbon-item"><FiCode /><div><strong>Build</strong><span>Work on meaningful products at scale</span></div></div>
        <div className="ribbon-item"><FiBarChart2 /><div><strong>Grow</strong><span>Advance your career with real impact</span></div></div>
        <div className="ribbon-item"><FiAward /><div><strong>Lead</strong><span>Lead with trust and inspire others</span></div></div>
      </section>

      <section className="career-section" id="why">
        <h2>Why join us</h2>
        <div className="career-grid four-up">
          {whyCards.map((card) => (
            <article className="career-card small" key={card.title}>
              <div className="career-card-icon">{card.icon}</div>
              <h3>{card.title}</h3>
              <p>{card.copy}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="career-feature" id="culture">
        <div className="career-feature-image">
          <img src="/ca1.jpg" alt="Team collaboration" />
        </div>
        <div className="career-feature-copy">
          <p className="theme-kicker">Our people</p>
          <h2>Inclusive teams</h2>
          <p>
            A culture built on trust, respect, and shared success. Our diverse teams collaborate
            across geographies and backgrounds to solve complex challenges and deliver exceptional
            results for our clients.
          </p>
          <div className="career-mini-grid">
            <div><FiUsers /><strong>Diverse by design</strong><span>Different perspectives, stronger solutions.</span></div>
            <div><FiHeart /><strong>One team</strong><span>Open communication and shared goals.</span></div>
            <div><FiAward /><strong>Client impact</strong><span>We deliver technology that makes a difference.</span></div>
          </div>
        </div>
      </section>

      <section className="career-section" id="open-roles">
        <h2>Open roles</h2>
        <div className="career-grid four-up">
          {openRoles.map((role) => (
            <article className="career-card role-card" key={role.title}>
              <div className="career-card-icon">{role.icon}</div>
              <h3>{role.title}</h3>
              <p>{role.copy}</p>
              <a href="/careers">View role <FiArrowRight /></a>
            </article>
          ))}
        </div>
      </section>

    </div>
  );
};

export default Career;
